module.exports = __webpack_public_path__ + "img/mercado-pago.e7c9abd3.svg";